import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Box, Divider, Flex } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { PlanType } from "sdk/types";
import { pricesByBillingIntervalAndPlan } from "~/constants";
import { CardContainer } from "./CardContainer";
import { CardTitle } from "./CardTitle";
import { ChargesOverview } from "./ChargesOverview";
import { CouponInfoSection } from "./CouponInfoSection";
import { InvoiceAndPromoCode } from "./InvoiceAndPromoCode";
import { Values } from "./types";

interface Props {
  message: string | null;
  submitButton: ReactNode;
  type: PlanType;
}

export const Summary: FC<Props> = ({ message, submitButton, type }) => {
  const { t } = useTranslation();
  const {
    values: { billingInterval },
  } = useFormikContext<Values>();
  const fullPrice = pricesByBillingIntervalAndPlan[billingInterval][type];

  return (
    <CardContainer maxW={{ base: "unset", md: "22.875rem" }} gap={4}>
      <CardTitle>{t("planPayment.formSummary")}</CardTitle>
      <InvoiceAndPromoCode
        billingInterval={billingInterval}
        fullPrice={fullPrice}
        type={type}
      />
      <Divider borderColor="th.cream3" borderWidth="1px" my="1rem" />
      <ChargesOverview
        billingInterval={billingInterval}
        fullPrice={fullPrice}
        type={type}
      />
      <CouponInfoSection type={type} />
      {message && (
        <Box color="error-new" mt={4} textAlign="center">
          {message}
        </Box>
      )}
      <Flex justify="center" mt="1rem" w="full">
        {submitButton}
      </Flex>
    </CardContainer>
  );
};
